import React, { useState } from 'react';
import { Button } from 'primereact/button';
import { Divider } from 'primereact/divider';
import ChassisDropdown from '../../../../components/common/ChassisDropdown';
import { useLanguage } from '../../../../contexts/LanguageContext';

export default function VehicleWarrantyInformationFilter({ onApplyFilters, onResetFilters }) {
    const { th } = useLanguage();

    const [filterOpen, setFilterOpen] = useState(true);
    const [filters, setFilters] = useState({
        sasiNo: null,
        zNumber: null
    });

    const toggleOpen = () => setFilterOpen((p) => !p);

    const setField = (field, value) => {
        setFilters({ ...filters, [field]: value });
    };

    const apply = () => {
        onApplyFilters?.({
            sasiNo: filters.sasiNo || undefined,
            zNumber: filters.zNumber || undefined
        });
    };

    const reset = () => {
        setFilters({
            sasiNo: null,
            zNumber: null
        });
        onResetFilters?.();
    };

    return (
        <div className="generic-table-filter">
            <div className="grid">
                <div className="col-12 md:col-6 flex justify-content-start">
                    <Button icon="pi pi-filter" label={th('vehicleWarrantyInformation.filter.advancedFilter')} onClick={toggleOpen} outlined={!filterOpen} />
                </div>
            </div>

            {filterOpen && (
                <div className="mt-3">
                    <Divider />
                    <div className="text-xl font-medium mb-3">{th('vehicleWarrantyInformation.filter.advancedFilters')}</div>

                    <div className="flex flex-wrap gap-2" style={{ alignItems: 'end' }}>
                        <div className="flex-auto" style={{ minWidth: 240, maxWidth: 320 }}>
                            <div className="field mb-2 p-1">
                                <label className="block mb-1 text-sm">{th('vehicleWarrantyInformation.columns.SasiNo')}</label>
                                <ChassisDropdown value={filters.sasiNo} onChange={(val) => setField('sasiNo', val)} className="w-full" placeholder={th('vehicleWarrantyInformation.filter.sasiNoPlaceholder')} />
                            </div>
                        </div>
                        <div className="flex-auto" style={{ minWidth: 240, maxWidth: 320 }}>
                            <div className="field mb-2 p-1">
                                <label className="block mb-1 text-sm">{th('vehicleWarrantyInformation.filter.zNumber')}</label>
                                <input
                                    type="number"
                                    className="p-inputtext p-component w-full"
                                    value={filters.zNumber ?? ''}
                                    onChange={(e) => setField('zNumber', e.target.value === '' ? null : Number(e.target.value))}
                                    placeholder={th('vehicleWarrantyInformation.filter.zNumberPlaceholder')}
                                    min={0}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="flex justify-content-start mt-3">
                        <Button label={th('vehicleWarrantyInformation.filter.reset')} icon="pi pi-refresh" className="p-button-outlined mr-2" onClick={reset} />
                        <Button label={th('vehicleWarrantyInformation.filter.apply')} icon="pi pi-check" onClick={apply} />
                    </div>
                </div>
            )}
        </div>
    );
}
